import { useShallow } from 'zustand/react/shallow'
import { useEphemeralStore } from '../../../../state/useEphemeralStore'
import { windowSizes } from '../../../../state/windowState/windowSignals'

export default function MapToolbar({
    position,
    children,
}: {
    position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
    children: React.ReactNode
}) {
    const { mapIsFullscreen } = useEphemeralStore(
        useShallow((s) => {
            return {
                mapIsFullscreen: s.mapIsFullscreen,
            }
        })
    )

    return (
        <div
            style={{
                zIndex: 1000,
                position: 'absolute',
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                ...(position === 'top-left'
                    ? {
                          top: mapIsFullscreen
                              ? `${windowSizes.value.insets.insets.top + 16}px`
                              : '16px',
                          left: '16px',
                      }
                    : {}),
                ...(position === 'top-right'
                    ? {
                          top: mapIsFullscreen
                              ? `${windowSizes.value.insets.insets.top + 16}px`
                              : '16px',
                          right: '16px',
                      }
                    : {}),
                ...(position === 'bottom-left'
                    ? {
                          bottom: mapIsFullscreen
                              ? `${
                                    windowSizes.value.insets.insets.bottom + 16
                                }px`
                              : '86px',
                          left: '16px',
                      }
                    : {}),
                ...(position === 'bottom-right'
                    ? {
                          bottom: mapIsFullscreen
                              ? `${
                                    windowSizes.value.insets.insets.bottom + 16
                                }px`
                              : '86px',
                          right: '16px',
                      }
                    : {}),
            }}
        >
            {children}
        </div>
    )
}
